import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, Card as BSCard, Col, Row } from 'reactstrap'
import { ReportBuilderProvider, useReportBuilderContext } from './ReportBuilderContext'
import QueryBuilderCard from './QueryBuilder'
import ResultsCard from './Results'
import type { ReportBuilderModel } from './fields'

export interface MongoQuery {
  model: ReportBuilderModel
  match: Record<string, any>
  pipeline?: Array<Record<string, any>>
}

const BuilderBreadcrumb: React.FC = () => {
  const { title, isNew } = useReportBuilderContext()
  return (
    <BSCard className='mb-2 p-2 ps-3 small text-body-secondary'>
      <Breadcrumb className='mb-0' listClassName='mb-0'>
        <BreadcrumbItem>
          <Link className='text-reset' to='/cat/views/reportbuilder'>Reports</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          {isNew ? 'Create New' : (title ?? '...')}
        </BreadcrumbItem>
      </Breadcrumb>
    </BSCard>
  )
}

const Builder: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  if (id === undefined) return null

  return (
    <ReportBuilderProvider id={id}>
      <BuilderBreadcrumb />
      <Row>
        <Col>
          <QueryBuilderCard />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <ResultsCard />
        </Col>
      </Row>
    </ReportBuilderProvider>
  )
}

export default Builder
